"use client";
{
  /* eslint-disable @next/next/no-img-element */
}

import React from 'react'
import DefaultHeader from './DefaultHeader'
import { stickyNav } from '../../common/utilits'
import { useEffect } from "react";
import { usePathname } from 'next/navigation';


export function Header({ extraClass }) {
  const router = usePathname();

  useEffect(() => {
    stickyNav(extraClass);
  }, []);

  return (
    <DefaultHeader  
    transparent={router === '/' ? true : false}
    extraClass = {extraClass}
    />
  )
}
